module.exports = __webpack_public_path__ + "img/Schlesinger.e50bf343.jpeg";